import useAxios from '../../library/axios'; 

import {IEntityAction} from './interface';


const _ = () => {

    const axios = useAxios();

    const getLastErrorMessage = async () : Promise<string>  => {        
      const {data} = (await axios.get(`/api/home/getLastErrorMessage`));
      return await data;
    }

    
    
    const getActionsByEntity = async (objectDataDef  : string )  => {        
        const {data} = (await axios.get(`/api/home/getActionsByEntity/${objectDataDef}`));
        return await data;
      }

    const executeEntityAction = async (entityAction: IEntityAction )  => 
      await (await axios.post('/api/home/executeEntityAction', entityAction)).data;

    const executeEntitiesAction = async (entitiesAction: IEntityAction[] )  => 
      await (await axios.post('/api/home/executeEntitiesAction', entitiesAction)).data;
    
    const getReportsByEntity = async (objectDataDef: string, objectKey: string)  => {        
        const {data} = (await axios.get(`/api/home/getReportsByEntity/?objectDataDef=${objectDataDef}&objectKey=${objectKey}`));
        return await data;
    }

    const generateReportAsPdf = async (objectDataDef: string, objectKey: string, objectEditionID: number, reportLayoutID: number, language: string)  => {        
      const {data} = (await axios.get(`/api/home/generateReportAsPdf/?objectDataDef=${objectDataDef}&objectKey=${objectKey}&objectEditionID=${objectEditionID}&reportLayoutID=${reportLayoutID}&language=${language}`));
      return await data;
    }

    const generateReportAsPdfEx = async (objectDataDef: string, objectKey: string, routine: string, reportLayoutID: number, language: string)  => {        
      const {data} = (await axios.get(`/api/home/generateReportAsPdfEx/?objectDataDef=${objectDataDef}&objectKey=${objectKey}&routine=${routine}&reportLayoutID=${reportLayoutID}&language=${language}`));
      return await data;
    }

    const getTemplateDocsByEntity = async (objectDataDef: string, objectKey: string)  => {        
      const {data} = (await axios.get(`/api/home/getTemplateDocsByEntity/?objectDataDef=${objectDataDef}&objectKey=${objectKey}`));
      return await data;
    }

    const mergeDocumentAsPdf = async (objectDataDef: string, objectKey: string, documentCode: string, language: string)  => {        
      const {data} = (await axios.get(`/api/home/mergeDocumentAsPdf/?objectDataDef=${objectDataDef}&objectKey=${objectKey}&documentCode=${documentCode}&language=${language}`));
      return await data;
    }

    

    return {
        getLastErrorMessage,

        getActionsByEntity,
        getReportsByEntity,
        getTemplateDocsByEntity,
        generateReportAsPdf,
        generateReportAsPdfEx,
        mergeDocumentAsPdf,
        
        executeEntityAction,
        executeEntitiesAction
    } 
}

export default _;